var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "section" }, [
      _c("div", { staticClass: "container is-fluid" }, [
        _c("div", { staticClass: "columns is-multiline" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }